import Swiper from 'swiper';

/**
 * コモンクラス
 * @constructor
 */
class Slider {
    constructor() {

    }
    /**
     * コモン
     */
    init() {
        var swiper_top = {
            autoplay: {
            delay: 4000,
            disableOnInteraction: false
            },
            loop: true,
            speed: 400,
            slidesPerView: 1,
            spaceBetween: 0,
            // navigation: {
            //     nextEl: '.swiper-button-next',
            //     prevEl: '.swiper-button-prev',
            // },
            pagination: {
                el: '.m-slide__pagination', //ページネーションの要素
                type: 'bullets', //ページネーションの種類
                clickable: true, //クリックに反応させる
            },
            breakpoints: {
                768: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                }
            }
        };

        var swiper_sec = {
            // autoplay: {
            // delay: 4000,
            // disableOnInteraction: false
            // },
            loop: true,
            speed: 400,
            // slidesPerView: 4,
            // spaceBetween: 0,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.m-slide2__pagination', //ページネーションの要素
                type: 'bullets', //ページネーションの種類
                clickable: true, //クリックに反応させる
            },
            breakpoints: {
                768: {
                    slidesPerView: 1,
                    // spaceBetween: 15,
                }
            }
        };

        $(window).on('load', function () {
            var swiperTop = new Swiper('.swiper_top', swiper_top);
            var swiperTop = new Swiper('.swiper_sec', swiper_sec);
        });

    }

}

export default Slider;
